export default class LSIntegrationStreamit {
    constructor() {
        this.init();
    }

    init() {
        new MovieLiveStreamIntegration();
        new VideoLiveStreamIntegration();
        new TvshowLiveStreamIntegration();
    }
}

/**
 * Base Integration class that handles common functionality
 */
class BaseLiveStreamIntegration {
    constructor(type) {
        this.type = type;
        this.initHooks();
    }

    /**
     * Register all hooks to extend validation and form data.
     */
    initHooks() {
        if (typeof wp.hooks === 'undefined' || typeof wp.hooks.addFilter === 'undefined') {
            console.warn('wp.hooks.addFilter is not available.');
            return;
        }

        wp.hooks.addFilter(
            `${this.type}_form_validation_rules`,
            `${this.type}_live_stream_integration_validation_rules`,
            this.extendValidationRules.bind(this)
        );

        wp.hooks.addFilter(
            `${this.type}_form_validation_messages`,
            `${this.type}_live_stream_integration_validation_messages`,
            this.extendValidationMessages.bind(this)
        );

        wp.hooks.addFilter(
            `${this.type}_form_data`,
            `${this.type}_live_stream_integration_form_data`,
            this.extendFormData.bind(this)
        );

        wp.hooks.addFilter(
            `${this.type}_form_invalid_handler`,
            `${this.type}_live_stream_integration_form_invalid_handler`,
            this.handleValidationErrors.bind(this)
        )
    }

    // Function to handle validation errors
    handleValidationErrors(validator) {
        // Clear existing error messages
        jQuery('.ls-validation-error-message').each(function () {
            jQuery(this).find('span.error-msg').remove();
        });
        // Add error indicators for current errors
        if (validator?.errorList) {
            validator.errorList.forEach((error) => {
                const adsElement = jQuery(error.element).closest('.ls-validation-error');
                const validationError = adsElement.find('.ls-validation-error-message');

                if (validationError.length > 0 && validationError.find('> span.tab-error').length === 0) {
                    validationError.find('.title-text').append('<span class="error-msg"> Error</span>');
                }
            });
        }
    }

    /**
     * Extend validation rules
     */
    // extendValidationRules(rules) {

    //        // Custom validator method for image URL extensions
    //     jQuery.validator.addMethod("imageUrl", function(value, element) {
    //         if (this.optional(element)) {
    //             return true; // Skip if the field is optional
    //         }

    //         try {
    //             const url = new URL(value); // Parse the URL
    //             const pathname = url.pathname.toLowerCase();

    //             // Define allowed image extensions (e.g., from LSAjax.allow_image_type)
    //             const imageExtensions = LSAjax.allow_image_type || ['jpg', 'jpeg', 'png', 'gif', 'webp'];

    //             // Check if the path ends with a valid image extension
    //             return imageExtensions.some(ext => pathname.endsWith(`.${ext.toLowerCase()}`));
    //         } catch (e) {
    //             return false; // Invalid URL structure
    //         }
    //     }, LSAjax.errorMessages.error_invalid_image_url);

    //     // Add new validation rules
    //     rules.vast_url = {
    //         required: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'vast' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
    //         },
    //         url:  function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'vast' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
    //         },
    //     };

    //     rules.mid_roll_adds_time = {
    //         number: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         },
    //         min: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable' ? 0 : false;
    //         },
    //     };
    //     rules["mid_roll_ads[0][skip_duration]"] = {
    //         number:  function () {
    //             return jQuery('input[name="mid_roll_ads[0][enable_skip_button]"]:checked').val() === 'yes' && jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         },
    //         min:  function () {
    //             return jQuery('input[name="mid_roll_ads[0][enable_skip_button]"]:checked').val() === 'yes' && jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable' ?  0 : false;
    //         },
    //     }
    //     rules['mid_roll_ads[0][adds_url]'] = {
    //         required: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         },
    //         url:  function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'full_screen' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         },
    //     };

    //     rules['mid_roll_ads[0][adds_title]'] = {
    //         required: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         }
    //     }
    //     rules['pre_role_add[0][adds_url]'] = {
    //         required: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="pre_roll_add_display"]:checked').val() === 'enable' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
    //         },
    //         url:  function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery('input[name="pre_roll_add_display"]:checked').val() === 'enable' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
    //         },
    //     };

    //     rules['mid_roll_ads[0][adds_branding_url]'] = {
    //         url: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         },
    //         imageUrl: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         },
    //     }
    //     rules['mid_roll_ads[0][adds_cta_url]'] = {
    //         url: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('#adds_type').val() == 'html' && jQuery(`#adds_html_structure_type_field_0`).val() == 'companion' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
    //         },
    //     }
    //     rules['post_role_add[0][adds_url]'] = {
    //         url: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('input[name="post_roll_add_display"]:checked').val() === 'enable' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
    //         },
    //         required: function () {
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('input[name="post_roll_add_display"]:checked').val() === 'enable' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
    //         }
    //     }
    //     rules['post_role_add[0][skip_duration]'] = {
    //         number: function(){
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="post_roll_add_display"]:checked').val() == 'enable'
    //         },
    //         min: function(){
    //             return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' && jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' && jQuery('input[name="post_roll_add_display"]:checked').val() == 'enable' ? 0 : false
    //         },
    //     }
    //     return rules;
    // }

    extendValidationRules(rules) {
        // Custom validator method for image URL extensions
        jQuery.validator.addMethod("imageUrl", function (value, element) {
            if (this.optional(element)) {
                return true; // Skip if the field is optional
            }

            try {
                const url = new URL(value); // Parse the URL
                const pathname = url.pathname.toLowerCase();

                // Define allowed image extensions (e.g., from LSAjax.allow_image_type)
                const imageExtensions = LSAjax.allow_image_type || ['jpg', 'jpeg', 'png', 'gif', 'webp'];

                // Check if the path ends with a valid image extension
                return imageExtensions.some(ext => pathname.endsWith(`.${ext.toLowerCase()}`));
            } catch (e) {
                return false; // Invalid URL structure
            }
        }, LSAjax.errorMessages.error_invalid_image_url);

        // Function to generate rules for a specific index
        const getMidRollRules = (index) => {
            return {
                [`mid_roll_ads[${index}][skip_duration]`]: {
                    number: function () {
                        return jQuery(`input[name="mid_roll_ads[${index}][enable_skip_button]"]:checked`).val() === 'yes' &&
                            jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                    min: function () {
                        return jQuery(`input[name="mid_roll_ads[${index}][enable_skip_button]"]:checked`).val() === 'yes' &&
                            jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable' ? 0 : false;
                    },
                },
                [`mid_roll_ads[${index}][adds_url]`]: {
                    required: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                    url: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'full_screen' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                },
                [`mid_roll_ads[${index}][adds_title]`]: {
                    required: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    }
                },
                [`mid_roll_ads[${index}][adds_branding_url]`]: {
                    url: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                    imageUrl: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                },
                [`mid_roll_ads[${index}][adds_cta_url]`]: {
                    url: function () {
                        return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                            jQuery('#adds_type').val() == 'html' &&
                            jQuery(`#adds_html_structure_type_field_${index}`).val() == 'companion' &&
                            jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                            jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
                    },
                }
            };
        };

        // Add rules for all existing mid-roll ads on page load
        jQuery('.ls_html_mid_roll_adds').each(function () {
            const index = jQuery(this).attr('rel');

            if (index !== undefined) {
                const midRollRules = getMidRollRules(index);
                jQuery.extend(rules, midRollRules);
            }
        });


        // Add other validation rules
        rules.vast_url = {
            required: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'vast' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
            },
            url: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'vast' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() === 'enable';
            },
        };

        rules.mid_roll_adds_time = {
            number: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                    jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable';
            },
            min: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                    jQuery('input[name="mid_roll_add_display"]:checked').val() === 'enable' ? 0 : false;
            },
        };

        rules['pre_role_add[0][adds_url]'] = {
            required: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="pre_roll_add_display"]:checked').val() === 'enable' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
            url: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="pre_roll_add_display"]:checked').val() === 'enable' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
        };

        rules['post_role_add[0][adds_url]'] = {
            url: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="post_roll_add_display"]:checked').val() === 'enable' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            },
            required: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="post_roll_add_display"]:checked').val() === 'enable' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable';
            }
        };

        rules['post_role_add[0][skip_duration]'] = {
            number: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                    jQuery('input[name="post_roll_add_display"]:checked').val() == 'enable';
            },
            min: function () {
                return jQuery('input[name="ads_source_preference"]:checked').val() === 'manually' &&
                    jQuery('#adds_type').val() == 'html' &&
                    jQuery('input[name="ls_adds_enable_disable"]:checked').val() == 'enable' &&
                    jQuery('input[name="post_roll_add_display"]:checked').val() == 'enable' ? 0 : false;
            },
        };
        return rules;
    }

    /**
     * Extend validation messages
     */
    extendValidationMessages(messages) {
        // Add messages for new rules
        messages.vast_url = {
            required: LSAjax.errorMessages.vast_url,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages.mid_roll_adds_time = {
            number: LSAjax.errorMessages.mid_roll_adds_time_number,
            min: LSAjax.errorMessages.mid_roll_adds_time_min
        }

        messages['mid_roll_ads[0][adds_url]'] = {
            required: LSAjax.errorMessages.adds_url_required,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages['pre_role_add[0][adds_url]'] = {
            required: LSAjax.errorMessages.adds_url_required,
            url: LSAjax.errorMessages.adds_url_required
        };

        messages['mid_roll_ads[0][adds_branding_url]'] = {
            url: LSAjax.errorMessages.adds_url_required
        }

        messages['mid_roll_ads[0][adds_cta_url]'] = {
            url: LSAjax.errorMessages.adds_url_required
        }
        return messages;
    }

    /**
     * Add live stream field to form data
     */
    extendFormData(formData) {

        formData.adds_display = jQuery('input[name="ls_adds_enable_disable"]:checked').val();
        formData.adds_type = jQuery('#adds_type').val();
        formData.vast_url = jQuery('#vast_url').val();
        formData.mid_roll_add_display = jQuery('input[name="mid_roll_add_display"]:checked').val();
        formData.mid_roll_adds_time = jQuery('#mid_roll_adds_time').val();
        formData.mid_roll_ads = this.MidRollAddsList();
        formData.pre_roll_add_display = jQuery('input[name="pre_roll_add_display"]:checked').val();
        formData.pre_role_add = this.PreRollAddsList();
        formData.post_roll_add_display = jQuery('input[name="post_roll_add_display"]:checked').val();
        formData.post_role_add = this.PostRollAddsList();
        formData.ads_source_preference = jQuery('input[name="ads_source_preference"]:checked').val();
        return formData;
    }

    MidRollAddsList() {
        let add_lists = [];

        jQuery('.ls-ad-block-mid_roll').each(function (index, element) {
            const $adBlock = jQuery(element);
            if ($adBlock.css('display') !== 'none') {
                let ad = {};
                ad.adds_html_structure_type = $adBlock.find('select[name$="[adds_html_structure_type]"]').val();
                ad.adds_url = $adBlock.find('input[name$="[adds_url]"]').val();
                ad.adds_background_color = $adBlock.find('input[name$="[adds_background_color]"]').val();
                ad.adds_title = $adBlock.find('input[name$="[adds_title]"]').val();
                ad.adds_desc = $adBlock.find('textarea[name$="[adds_desc]"]').val();
                ad.adds_branding_url = $adBlock.find('input[name$="[adds_branding_url]"]').val();
                ad.adds_cta_url = $adBlock.find('input[name$="[adds_cta_url]"]').val();
                ad.adds_cta_text = $adBlock.find('input[name$="[adds_cta_text]"]').val();
                ad.enable_skip_button = $adBlock.find('input[name$="[enable_skip_button]"]:checked').val();
                ad.skip_duration = $adBlock.find('input[name$="[skip_duration]"]').val();
                ad.duration = parseInt($adBlock.find('input[name$="[duration]"]').val(), 10) || 5;

                add_lists.push(ad);
            }
        });

        return add_lists.length > 0 ? add_lists : '';
    }


    PreRollAddsList() {
        let add_lists = [];

        jQuery('.ls-ad-block-pre_roll ').each(function (index, element) {
            if (jQuery(element).css('display') !== 'none') {
                let ad = {};
                ad.adds_html_structure_type = jQuery(element).find('select[name$="[adds_html_structure_type]"]').val() || 'full_screen';
                ad.adds_url = jQuery(element).find('input[name$="[adds_url]"]').val();
                ad.enable_skip_button = jQuery(element).find('input[name$="[enable_skip_button]"]:checked').val();
                ad.skip_duration = jQuery(element).find('input[name$="[skip_duration]"]').val();
                add_lists.push(ad);
            }
        });
        return add_lists.length > 0 ? add_lists : '';
    }
    PostRollAddsList() {
        let add_lists = [];

        jQuery('.ls-ad-block-post_roll').each(function (index, element) {
            if (jQuery(element).css('display') !== 'none') {
                let ad = {};
                ad.adds_html_structure_type = jQuery(element).find('select[name$="[adds_html_structure_type]"]').val() || 'full_screen';
                ad.adds_url = jQuery(element).find('input[name$="[adds_url]"]').val();
                ad.enable_skip_button = jQuery(element).find('input[name$="[enable_skip_button]"]:checked').val();
                ad.skip_duration = jQuery(element).find('input[name$="[skip_duration]"]').val();
                add_lists.push(ad);
            }
        });
        return add_lists.length > 0 ? add_lists : '';
    }

}

/**
 * Movie specific implementation
 */
class MovieLiveStreamIntegration extends BaseLiveStreamIntegration {
    constructor() {
        super('movie');
    }
}

/**
 * Video specific implementation
 */
class VideoLiveStreamIntegration extends BaseLiveStreamIntegration {
    constructor() {
        super('video');
    }
}


/**
 * Tv-Show specific implementation
 */
class TvshowLiveStreamIntegration extends BaseLiveStreamIntegration {
    constructor() {
        super('tvshow');
    }
}
